export { default } from './RelatedArtists';
